import React from "react";
import { RaceProgram } from "@tvg/ts-types/Race";
import List from "./List";
import { Container } from "./styled-components";

interface Props {
  races: Array<RaceProgram>;
  isMobile?: boolean;
}

const RaceSelector: React.FC<Props> = ({ races, isMobile = false }) => (
  <Container>
    <List races={races} isMobileView={isMobile} />
  </Container>
);

export default RaceSelector;
